import React, { useState } from 'react';
import { AdfNodeProps } from './AdfModelTypes';
import { useAdfDocumentContext } from './AdfViewer';

interface FileMediaProps {
    id: string;
    collection: string;
    width?: number;
    height?: number;
    alt?: string;
}

const FileMedia = React.memo(({ width, height, alt }: FileMediaProps) => {

    const { jiraIssueId } = useAdfDocumentContext();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    if (error) {
        return <div className="media-placeholder">
            <span>{alt}</span>
        </div>;
    }

    return <div className="media-item">
        <img
            src={`/api/v2/jira.attachments.content?jiraIssueId=${jiraIssueId}&filename=${alt}`}
            alt={alt || 'Media content'}
            width={width}
            height={height}
            onLoad={() => {
                setLoading(false);
            }}
            onError={() => {
                setLoading(false);
                setError(true);
            }}
            style={{ display: error || loading ? 'none' : 'block' }}
        />
        {(error || loading) && <div className="media-placeholder">
            <span>{loading ? 'Loading' : ''} {alt}</span>
        </div>}
    </div>;
});

const LinkMedia = React.memo(({ id }: { id: string }) => {
    return <div className="media-item">
        <a href={id} target="_blank" rel="noopener noreferrer">
            <div className="media-link">
                <span>External Media Link</span>
            </div>
        </a>
    </div>;
});

const UnknownMedia = React.memo(({ type }: { type: string }) => {
    return <div className="media-item">
        <div className="media-placeholder">
            <span>Unknown media type: {type}</span>
        </div>
    </div>;
});

export const AdfMedia = React.memo(({ node }: AdfNodeProps) => {
    const { id, type, collection, width, height, alt } = node.attrs || {};
    if (type === 'file') {
        return <FileMedia id={id} collection={collection} width={width} height={height} alt={alt} />;
    }
    if (type === 'link') {
        return <LinkMedia id={id} />;
    }
    return <UnknownMedia type={type} />;
});
